<template>
  <div>
      
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-2">{{ $t('add')}} {{$tc('checklist', 1)}}</div>
      <router-link class="btn-blue" :to="{name:'List Checklists'}">{{ $tc('checklist', 2)}}</router-link>
    </div>
    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-4 col-xl-3 mb-1">
          <div class="d-flex align-items-center">
            <div 
            class="input-material"
              v-b-tooltip.hover
             :title="$t('checklist_name')"
            >
              <!-- @focus="onFocusHandler" -->
              <!-- :required="item.required" -->
              <input
                id="checklist_name"
                name="checklist_name"
                v-validate="'required'"
                v-model="checklist_name"
                placeholder="."
              />
              <label>{{ $t("checklistName" ) }}</label>
            </div>
            <!--Tooltip :title="$t('checklist_name')" /--->
          </div>
          <p class="error_message" style="margin-top:2px">
            <span
              v-if="submitted && errors.has('checklist_name')"
            >{{ errors.first('checklist_name') }}</span>
          </p>
        </div>

        <div class="col-lg-4 col-xl-3 mb-1">
          <div class="d-flex align-items-center">
            <!-- @focus="onFocusHandler" -->
            <!-- :required="item.required" -->
            <multiselect
              :options="categoryList"
              v-model="selected_category"
              :searchable="true"
              label="cc_name"
              track-by="cc_name"
              placeholder="Checklist Category"
              v-validate="'required'"
              name="selected_category"
              id="selected_category"
              :allowEmpty="false"
              :showLabels="false"
              v-b-tooltip.hover
             :title="$t('checklist_category')"
            ></multiselect>

            <!--Tooltip :title="$t('checklist_category')" /--->
          </div>
          <p class="error_message" style="margin-top:2px">
            <span
              v-if="submitted && errors.has('selected_category')"
            >{{ errors.first('selected_category') }}</span>
          </p>
        </div>

        <div class="col-lg-4 col-xl-3 mb-1">
          <div class="d-flex align-items-center">
            <!-- @focus="onFocusHandler" -->
            <!-- :required="item.required" -->
            <multiselect
              :options="cinema_list"
              v-model="selected_cinema"
              :searchable="true"
              label="cine_name"
              track-by="cine_name"
              placeholder="Cinema"
              v-validate="'required'"
              name="selected_cinema"
              id="selected_cinema"
              :allowEmpty="false"
              :showLabels="false"
              :disabled="isRoleID"
              v-b-tooltip.hover
             :title="$t('checklist_cinema')"
            ></multiselect>

            <!--Tooltip :title="$t('checklist_cinema')" /--->
          </div>
          <p class="error_message" style="margin-top:2px">
            <span
              v-if="submitted && errors.has('selected_cinema')"
            >{{ errors.first('selected_cinema') }}</span>
          </p>
        </div>

        <div class="col-lg-4 col-xl-3 mb-1">
          <div class="d-flex align-items-center pt-2 justify-content-start">
            <label class="mb-0 mr-2">{{ $t('active') }}</label>
            <label class="mb-0">
               <b-form-checkbox
                v-model="checklist_is_active"
                
                class="j-checkbox ml-2 pb-0"
                
              />
        
            </label>
          </div>
          
        </div>

        <div
          class="col-lg-9 col-xl-9 mb-3"
          v-for="(Items, itemIndex) in checkListItems"
          :key="itemIndex"
        >
          <div class="d-flex justify-content-center align-items-center">
            <div class="input-material">
              <input type="text" step="any" v-model="Items.item" placeholder="." />
              <label>{{ $tc('checklistItem')}}</label>
            </div>
            <div class>
              <button
                v-if="itemIndex === 0"
                @click.prevent.stop="increaseItem()"
                class="btn-transparent"
              >
                <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
              </button>
              <button v-else @click.prevent.stop="decreaseItem(itemIndex)" class="btn-transparent">
                <img src="@/assets/img/icons/minus.svg" height="35" width="35" />
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-12 text-center">
          <button
            :disabled="btenable"
            @click.prevent.stop="addChecklist()"
            class="btn-blue"
          >{{ $t('save') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import ChecklistService from "@/services/ChecklistService";
export default {
  data() {
    return {
      btenable: false,
      isRoleID: true,
      checklist_name: "",
      checklist_is_active: true,
      categoryList: [],
      cinema_list: [],
      selected_category: null,
      selected_cinema: null,
      submitted: false,
      checkListItems: [
        {
          item: ""
        }
      ]
    };
  },
  mounted() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    this.cinema_manager_add_edit_disabled = roleid;
    if (true) {
      this.isRoleID = false;
    }
    this.getCinemas(obj);
    this.getCategoryList();
  },
  methods: {
    addChecklist() {
      let flag = true;
      this.submitted = true;
      this.checkListItems.map(x => {
        if (x.item == "") {
          flag = false;
          return;
        }
      });
      if (flag == true) {
        this.$validator.validate().then(valid => {
          if (valid) {
            this.btenable = true;
            // let loader = this.$loading.show();

            // console.log("JSON.stringify :", JSON.stringify(finalObj));
            let payload = {
              checklist_name: this.checklist_name,
              category_id: this.selected_category.checklist_category_id,
              cinema_id: this.selected_cinema.cine_id,
              items_array: this.checkListItems,
              checklist_is_active: this.checklist_is_active
            };
            ChecklistService.AddChecklist(payload)
              .then(response => {
                this.btenable = false;
                const { data } = response;
                // loader.hide();
                if (data && data.status) {
                  this.$toasted.show(data.message);

                  this.$router.push({
                    path: "/cinema-manager/list-checklists"
                  });
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch(this._CatchError);
          } else {
            this.$toasted.show("Please enter all details");
          }
        });
      } else {
        this.$toasted.show("Please fill all checklist items");
      }
    },
    getCategoryList() {
      ChecklistService.GetCategories2()
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.categoryList = data.Records;
            console.log("this.categoryList :>> ", this.categoryList);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    getCinemas(cine_id) {
      MasterService.GetCinemas({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.cinema_list = data.Records;
            console.log("this.cinema_list :>> ", this.cinema_list);
            this.cinema_list.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                this.selected_cinema = x;
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    increaseItem: function() {
      this.checkListItems.push({
        item: ""
      });
    },
    decreaseItem: function(index) {
      this.checkListItems.splice(index, 1);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ChecklistComponents/addChecklist.vue